import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/index.css";
import "element-plus/es/components/message/style/css";
import "element-plus/es/components/message-box/style/css";
import AImg from "@/components/AImg";
import elementUi from "@/plugins/element-icon";
import "dayjs/locale/zh-cn";
import relativeTime from "dayjs/plugin/relativeTime";
import AiDot from "@/components/AiDot";
import dayjs from "dayjs";
dayjs.extend(relativeTime); // 相对时间
dayjs.extend(require("dayjs/plugin/duration"));
dayjs.locale("zh-cn"); // 使用本地化语言

const app = createApp(App);
app.component("AImg", AImg);
app.component("AiDot", AiDot);
app.use(elementUi);
app.use(store).use(router).mount("#app");
